import { FilterPredictedOn } from 'v2/core/services/queryBuilder/whereClause';
import { mapEQLValues } from './mapEQLValues';

export const mapFilterPredictedOn = (
  predictedOn?: FilterPredictedOn,
): string => {
  if (!predictedOn) {
    return '';
  }

  const operator = predictedOn.isAll ? 'all' : 'any';

  return ` on ${operator} (${mapEQLValues(predictedOn.values)})`;
};
